import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SideBar from '../../../newDashboard/SideBar';
import Header from '../../../newDashboard/Header';
import FilterSection from './_filter_section';
import TenantsTable from './_tenant_table';
import { mockTenants } from './_list_tenants';

const SalesLedger = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [selectedTenants, setSelectedTenants] = useState([]);
  const [filter, setFilter] = useState({
    monthRange: false,
    dateRange: false,
    startMonth: new Date(),
    endMonth: new Date(),
    startDate: new Date(),
    endDate: new Date(),
    category: 'all'
  });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('categoryC'); // State to track active tab
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTenants = async () => {
      setLoading(true);
      setTimeout(() => {
        setTenants(mockTenants);
        setLoading(false);
      }, 1000);
    };

    fetchTenants();
  }, []);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSelectTenant = (tenantId) => {
    setSelectedTenants(prev => {
      if (prev.includes(tenantId)) {
        return prev.filter(id => id !== tenantId);
      } else {
        return [...prev, tenantId];
      }
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedTenants(tenants.map(tenant => tenant.tenant_id));
    } else {
      setSelectedTenants([]);
    }
  };

  const generateInvoices = () => {
    if (selectedTenants.length === 0) {
      alert('Please select at least one tenant');
      return;
    }
    
    const selected = tenants.filter(tenant => selectedTenants.includes(tenant.tenant_id));
    console.log('Generating invoices for:', selected);
    alert(`Invoices generated for ${selected.length} tenants`);
  };

  const exportToCSV = () => {
    const headers = ['ID', 'Name', 'Category', 'Amount', 'Paid', 'Last Payment'];
    const csvContent = [
      headers.join(','),
      ...tenants.map(tenant => [
        tenant.tenant_id,
        `"${tenant.name}"`,
        tenant.category,
        tenant.amount,
        tenant.paid ? 'Yes' : 'No',
        tenant.lastPayment
      ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', 'tenants_ledger.csv');
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filteredTenants = tenants.filter(tenant => {
    if (filter.category !== 'all' && tenant.category !== filter.category) {
      return false;
    }
    
    if (filter.dateRange) {
      const lastPaymentDate = new Date(tenant.lastPayment);
      return lastPaymentDate >= filter.startDate && lastPaymentDate <= filter.endDate;
    }
    
    if (filter.monthRange) {
      const lastPaymentDate = new Date(tenant.lastPayment);
      const startMonth = new Date(filter.startMonth.getFullYear(), filter.startMonth.getMonth(), 1);
      const endMonth = new Date(filter.endMonth.getFullYear(), filter.endMonth.getMonth() + 1, 0);
      
      return lastPaymentDate >= startMonth && lastPaymentDate <= endMonth;
    }
    
    return true;
  });

  return (
    <>
      <div className={`reports_dashboard`}>
        <div className="container-fluid">
          {/* <FilterSection 
            filter={filter}
            setFilter={setFilter}
            navigate={navigate}
            exportToCSV={exportToCSV}
          /> */}
          
          <TenantsTable 
            tenants={tenants}
            selectedTenants={selectedTenants}
            handleSelectTenant={handleSelectTenant}
            handleSelectAll={handleSelectAll}
            loading={loading}
            generateInvoices={generateInvoices}
          />
          
          {/* Blue Tabs Section */}
          <div className="blue-tabs-container" style={{
            borderBottom: '3px solid #1890ff',
            marginTop: '20px',
            display: 'flex'
          }}>
            <button 
              className={`tab-button ${activeTab === 'categoryC' ? 'active' : ''}`}
              onClick={() => setActiveTab('categoryC')}
              style={{
                padding: '10px 20px',
                backgroundColor: activeTab === 'categoryC' ? '#1890ff' : '#e6f7ff',
                color: activeTab === 'categoryC' ? 'white' : '#1890ff',
                border: 'none',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              Category C Invoices
            </button>
            <button 
              className={`tab-button ${activeTab === 'etims' ? 'active' : ''}`}
              onClick={() => setActiveTab('etims')}
              style={{
                padding: '10px 20px',
                backgroundColor: activeTab === 'etims' ? '#1890ff' : '#e6f7ff',
                color: activeTab === 'etims' ? 'white' : '#1890ff',
                border: 'none',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              Generated eTIMS
            </button>
          </div>
          
          {/* Tab Content */}
          <div className="tab-content" style={{padding: '20px', border: '1px solid #ddd', borderTop: 'none'}}>
            {activeTab === 'categoryC' && (
              <div>
                <h3>Category C Invoices Content</h3>
                <p>This section would display Category C invoice details.</p>
              </div>
            )}
            {activeTab === 'etims' && (
              <div>
                <h3>Generated eTIMS</h3>
                <p>Generated eTIMS content would be displayed here.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesLedger;